<template>
    <div>
        <main-navigation/>

        <centered-card headline="Create a new Blog">
            <blog-form/>
        </centered-card>

    </div>
</template>

<script>

    import MainNavigation from '../../layout/MainNavigation.vue';
    import CenteredCard from '../../layout/CenteredCard.vue';
    import BlogForm from './BlogForm.vue';


    export default {
        name: '',
        metaInfo: {
            title: 'Create a new Blog'
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {},
        components:{
            MainNavigation,
            CenteredCard,
            BlogForm
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/user/blogs/CreateBlogPage.vue